import React, { useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faClock,
  faChevronLeft,
  faPlay,
  faPause,
  faUndo,
} from '@fortawesome/free-solid-svg-icons'
import useClearGameState from '../useClearGameState'
import GameContext from '../GameContext'
import {
  Container,
  LeftSideContainer,
  BackButton,
  DifficultyIndicator,
  RightSideContainer,
  Timer,
  TimerText,
  PlayPauseButton,
  RestartButton,
  ButtonText,
} from './styles'
import Data from '../../../data.json'

const GameControlBar: React.FC = () => {
  const {
    difficulty,
    isPaused,
    setIsPaused,
    hoursText,
    minutesText,
    secondsText,
    onStartTimer,
    onPauseTimer,
  } = useContext(GameContext)

  const onClearGameState = useClearGameState()
  const history = useHistory()

  useEffect(onClearGameState, [])

  const onPlayPause = (): void => {
    setIsPaused(!isPaused)
    if (isPaused) onStartTimer()
    else onPauseTimer()
  }

  const onReturnToMenu = (): void => {
    const playerWantsToLeave = window.confirm(Data.leaveGameNotice)

    if (playerWantsToLeave) history.goBack()
  }

  const onRestart = (): void => {
    if (isPaused) onClearGameState()
  }
  const totalPairs = difficulty / 2
  const difficultyIndicator = Data.difficultyIndicator.replace(
    '$numberOfPairs',
    `${totalPairs}`,
  )

  return (
    <Container>
      <LeftSideContainer>
        <BackButton onClick={onReturnToMenu}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </BackButton>

        <DifficultyIndicator>{difficultyIndicator}</DifficultyIndicator>
      </LeftSideContainer>

      <RightSideContainer>
        <Timer>
          <FontAwesomeIcon icon={faClock} />
          <TimerText>{`${hoursText}:${minutesText}:${secondsText}`}</TimerText>
        </Timer>

        <PlayPauseButton onClick={onPlayPause}>
          {isPaused ? (
            <FontAwesomeIcon icon={faPlay} />
          ) : (
            <FontAwesomeIcon icon={faPause} />
          )}
        </PlayPauseButton>

        <RestartButton isPaused={isPaused} onClick={onRestart}>
          <FontAwesomeIcon icon={faUndo} />
          <ButtonText>Restart</ButtonText>
        </RestartButton>
      </RightSideContainer>
    </Container>
  )
}

export default GameControlBar
